export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-Rewarding-guide.076d7da3.jpg";